import {Linktype} from "../../types/linktype";

export const noteslinks: Linktype[] = [
    /*{
        title: "Assessing coding and computer skills",
        link: "Computer-Skills",
        tag: "team-start"
    },
    {
        title: "Relevant yearly events - for sponsoring and community engagement",
        link: "Events",
        tag: "other"
    },
    {
        title: "iGEM introductory workshop",
        link: "iGEM-Workshop",
        tag: "team-start"
    },
    {
        title: "Travelling for iGEM - Statement Of Travel Expenses, Hostel Quotes and Co.",
        link: "Travel",
        tag: "bureaucracy"
    },
    {
        title: "Getting credits for iGEM",
        link: "Credits",
        tag: "other"
    },
    {
        title: "Human Practices and Ethics Introduction",
        link: "HP-Ethics",
        tag: "team-start"
    },
    {
        title: "Wiki Management",
        link: "Wiki-Management",
        tag: "wiki"
    },
    {
        title: "Steering Committee Presentations",
        link: "Steering-Committee-Presentations",
        tag: "other"
    },
    {
        title: "Non pursued topics from the least years",
        link: "Possible-Topics",
        tag: "other"
    },
    {
        title: "Schließberechtigungen",
        link: "Schließberechtigungen",
        tag: "bureaucracy"
    },
    {
        title: "Teambuilding",
        link: "Teambuilding",
        tag: "team-start"
    },
    {
        title: "Getting started in the CeBiTec: Account, Intranet, Email and Co.",
        link: "Cebitec",
        tag: "team-start"
    },
    {
        title: "Conflict Management",
        link: "Conflict-Management",
        tag: "other"
    },
    {
        title: "File organization and storage",
        link: "Files",
        tag: "other"
    },
    {
        title: "Sponsoring documentation and templates",
        link: "Sponsoring",
        tag: ""
    },
    {
        title: "Branding and Logos",
        link: "Branding",
        tag: ""
    },
    {
        title: "Press outreach",
        link: "Press",
        tag: ""
    },
    {
        title: "Planning Paris",
        link: "Paris-Planning",
        tag: ""
    },
    {
        title: "Consent and Release Forms",
        link: "Consent-Forms",
        tag: ""
    },*/
    {
        title: "The iGEM Sciebo",
        link: "Sciebo",
        tag: "infrastructure"
    },
    {
        title: "Getting access to the shared team email",
        link: "Team-Email",
        tag: "infrastructure"
    },
    {
        title: "Wiki & Documentation Guide",
        link: "https://liliana-sanfilippo.github.io/igem-wiki-guide/wiki-guide.pdf",
        tag: "wiki"
    }
]

/*
 {
        title: "",
        link: "",
        tag: ""
    }
 */